var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#055EB2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron_Right_Circle"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,0C7.2,0,0,7.2,0,16c0,8.8,7.2,16,16,16c8.8,0,16-7.2,16-16C32,7.2,24.8,0,16,0z M16,30C8.3,30,2,23.7,2,16 S8.3,2,16,2s14,6.3,14,14S23.7,30,16,30z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,8.3c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l6.2,6.3l-6.2,6.3c-0.4,0.4-0.4,1,0,1.4 c0.4,0.4,1,0.4,1.4,0l6.9-7c0.4-0.4,0.4-1,0-1.4L13.8,8.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.8b26ddf18f775feed62a207e516f35d4.svg";
export { ForwardRef as ReactComponent };